import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background: white;

  &:focus {
    border-color: #0B4F45;
  }

  &::placeholder {
    color: #999;
  }
`;

export const SuggestionsList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  color: #000;
`;

export const SuggestionItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
`;

export const ErrorMessage = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
`; 